"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ADD_APPEARANCE: function() {
        return ADD_APPEARANCE;
    },
    DELETE_APPEARANCE: function() {
        return DELETE_APPEARANCE;
    },
    GENERATE_APPEARANCES: function() {
        return GENERATE_APPEARANCES;
    },
    RESET_APPEARANCES: function() {
        return RESET_APPEARANCES;
    },
    SELECT_SEGMENT_WINNER: function() {
        return SELECT_SEGMENT_WINNER;
    },
    UPDATE_APPEARANCE: function() {
        return UPDATE_APPEARANCE;
    },
    UPDATE_MANAGER: function() {
        return UPDATE_MANAGER;
    },
    UPDATE_WINNER: function() {
        return UPDATE_WINNER;
    }
});
const ADD_APPEARANCE = "ADD_APPEARANCE";
const UPDATE_APPEARANCE = "UPDATE_APPEARANCE";
const DELETE_APPEARANCE = "DELETE_APPEARANCE";
const GENERATE_APPEARANCES = "GENERATE_APPEARANCES";
const RESET_APPEARANCES = "RESET_APPEARANCES";
const UPDATE_MANAGER = "UPDATE_MANAGER";
const UPDATE_WINNER = "UPDATE_WINNER";
const SELECT_SEGMENT_WINNER = "SELECT_SEGMENT_WINNER";
